import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavigationItem } from '@clean-code/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxPermissionsModule } from 'ngx-permissions';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-navigation-item',
    templateUrl: './navigation-item.component.html',
    imports: [
        CommonModule,
        RouterModule,
        TranslocoModule,
        FontAwesomeModule,
        NgxPermissionsModule,
    ]
})
export class NavigationItemComponent {
  @Input()
  item: NavigationItem;

  public readonly faChevronDown = faChevronDown;
  public readonly faChevronRight = faChevronRight;

  public expanded = false;

  public get hasChildren(): boolean {
    return !!this.item?.children?.length;
  }

  public toggle(): void {
    this.expanded = !this.expanded;
  }
}
